import { render } from "./StockSummary.vue?vue&type=template&id=92077d0a"
import script from "./StockSummary.vue?vue&type=script&lang=ts"
export * from "./StockSummary.vue?vue&type=script&lang=ts"
script.render = render

export default script